import React from 'react';
export const NqTemplateContext = React.createContext(); 